__turbopack_context__.v({
  "dropdown": "index-module__dRakmW__dropdown",
  "icon": "index-module__dRakmW__icon",
  "inline": "index-module__dRakmW__inline",
  "item": "index-module__dRakmW__item",
  "label": "index-module__dRakmW__label",
  "scrollIcon": "index-module__dRakmW__scrollIcon",
  "select": "index-module__dRakmW__select",
  "text": "index-module__dRakmW__text",
  "trigger": "index-module__dRakmW__trigger",
});
